export const __computeConstructionAndThreadCount = (val1, val2) => {
  return val1 ? `${val1} x ${val2}` : '--';
};

export const DATE_TIME_RAW = 'Do MMMM YYYY, hh:mm A';
